import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { host } from '../../function/api'

const initialState = {
    UserMainperson: [],
    UserMainsuccess: false,
    UserMainstatus: false,
    UserMainloading: false,
    UserMainmessage: '',
    UserMainerrorName: '',
    UserMainerrorMobile: '',
    UserMainerrorNationalId: '',
    UserMainerrorFlag: '',
    UserMainerrorPassword: '',
   
}

export const userUpdate = createAsyncThunk(
    'user/update',
    async (data, thunkAPI) => {
        try {
            console.log(data)
            const response = await axios({
                method: 'PATCH',
                url: `${host}user/${data.id}`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)


export const fetchUser = createAsyncThunk(
    'fetch/user',
    async (user, thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}user/${user}`,
                data: user,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)


const userManagment = createSlice({
    name: 'userManagment',
    initialState,
    reducers: {

    },
    extraReducers: {
        [userUpdate.fulfilled]: (state, { payload }) => {
            state.UserMainloading = false;
            state.UserMainsuccess = true;
            state.UserMainstatus = true
            state.UserMainmessage = payload.message;
        },
        [userUpdate.pending]: (state) => {
            state.UserMainloading = true;
            state.UserMainstatus = false
            state.UserMainsuccess = false
            state.UserMainerrorName = ''
            state.UserMainerrorMobile = ''
            state.UserMainerrorFlag = ''
            state.UserMainerrorPassword = ''
        },
        [userUpdate.rejected]: (state, { payload }) => {
            state.UserMainloading = false;
            state.UserMainsuccess = false;
            state.UserMainstatus = false
            state.UserMainmessage = payload.response.data.message;
            if (payload.response.data.error) {
                state.UserMainerrorName = payload.response.data.error.name
                state.UserMainerrorMobile = payload.response.data.error.mobile
                state.UserMainerrorFlag = payload.response.data.error.flag
                state.UserMainerrorPassword = payload.response.data.error.password
            } else {
                state.UserMainerrorName = ''
                state.UserMainerrorMobile = ''
                state.UserMainerrorFlag = ''
                state.UserMainerrorPassword = ''
            }
        },


      


        [fetchUser.fulfilled]: (state, action) => {
            state.UserMainloading = false;
            state.UserMainsuccess = true;
            state.UserMainstatus = true
            state.UserMainperson = action.payload.data
            state.UserMainmessage = action.payload.message
        },
        [fetchUser.pending]: (state) => {
            state.UserMainloading = true;
            state.UserMainsuccess = false;
            state.UserMainstatus = false
            state.UserMainperson = [];
            state.UserMainmessage = ""
        },
        [fetchUser.rejected]: (state, { payload }) => {
            state.UserMainloading = false;
            state.UserMainsuccess = false;
            state.UserMainstatus = false
            state.UserMainmessage = payload.response.data.message
        }
    }
})

export const { } = userManagment.actions;
export default userManagment.reducer;